import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

const ProgressBar = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const path = location.pathname

  const getProgress = () => {
    if (path.includes("success")) {
      return 100
    } else if (path.includes("ticket-details")) {
      return 66.66
    } else if (path.includes("checkout")) {
      return 80
    } else {
      return 33.33
    }
  }

  const progress = getProgress()

  return (
    <>
      <div className="w-full h-[1px] bg-white opacity-10"></div>
      <div 
        className="w-full h-1 bg-progress_bar_background"
        role="progressbar"
        aria-label={t("progress.registration_progress", "Registration progress")}
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full bg-theme_accent transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </>
  )
}

export default ProgressBar
